module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\r\n       <input type="text" id="acuerdos_tipo" class="form-control"  value="'+
((__t=(attributes.acuerdos_tipo))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n        <!--<select id="acuerdos_tipo" class="form-control" '+
((__t=(disabled))==null?'':_.escape(__t))+
'>\r\n                <option value="">[ -- ]</option>\r\n                ';

                for (var i = 1; i <= 50; i++) {
                        var selected = "";
                        
                        if (attributes.acuerdos_tipo === 'TIPOACUERDOS_' + i)          
                                selected = "selected";                               
                        if (lang['TIPOACUERDOS_' + i])
                                print('<option value="TIPOACUERDOS_' + i + '" ' + selected + '>' + lang['TIPOACUERDOS_' + i] + '</option>');
                        
                }
                
__p+='\r\n                \r\n        </select> -->\r\n</td>\r\n<!--\r\n<td>\r\n        <input type="text" id="acuerdos_organo" class="form-control"  value="'+
((__t=(attributes.acuerdos_organo))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n    </td>\r\n-->\r\n    \r\n<td>\r\n    <div class="input-group" id="dtpickerAcuerdos">\r\n        <input type=\'text\' id="acuerdos_fecha" class="form-control date"  value="'+
((__t=(attributes.acuerdos_fecha))==null?'':_.escape(__t))+
'"  '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n        <span class="input-group-addon">\r\n            <span class="glyphicon glyphicon-calendar"></span>\r\n        </span>\r\n    </div>\r\n</td>\r\n<td>\r\n    <input type="text" id="acuerdos_destino" class="form-control"  value="'+
((__t=(attributes.acuerdos_destino))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td>    \r\n    <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n</td>\r\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/acuerdos.ejs
// module id = 154
// module chunks = 0